import TaskFilter from "@/components/task-filter/TaskFilter";
import DisplayOptionsPopover from "./task-table/DisplayOptionsPopover";

export default function SimpleTaskListHeader({ title, icon }: { title: string; icon: React.ElementType }) {
    const IconComponent = icon;

    return (
        <>
            <div
                data-slot="header"
                className="px-4 py-2 pl-1.5 text-zinc-600 flex items-center gap-2 border-b justify-between"
            >
                <div className="flex items-center">
                    <span className="size-9 grid place-items-center">
                        <IconComponent className="size-4" />
                    </span>
                    <span className="ml-2  text-zinc-600">{title}</span>
                </div>
            </div>
            <div
                data-slot="filter"
                className="px-3 py-1  text-zinc-500 flex items-center gap-2 border-b justify-between"
            >
                <div className="mr-auto">
                    <TaskFilter />
                </div>
                <div className="flex items-center gap-2">
                    <DisplayOptionsPopover />
                </div>
            </div>
        </>
    );
}
